<template>
  <div class="pa-global-header" :class="globalHeaderClass">
    <div class="only-mobile">
      <ProgressBar
       :currentValue="progressBarParams.currentValue"
       :maxValue="progressBarParams.maxValue"
       :additionalClass="progressBarClass"
      />
    </div>
    <div class="main-field">
      <div class="left-side">
        <IconBar ref="iconBarField" />
      </div>

      <div class="right-side">
        <FlashLine />
        <div class="only-pc">
          <ProgressBar
           :currentValue="progressBarParams.currentValue"
           :maxValue="progressBarParams.maxValue"
           :additionalClass="progressBarClass"
          />
        </div>
      </div>
    </div>
    <PageTitleBar />
  </div>
</template>

<script>
import ProgressBar  from '@/components/Parts/GlobalHeaderForLoginedView/ProgressBar/ProgressBar.vue'
import IconBar      from '@/components/Parts/GlobalHeaderForLoginedView/IconBar/IconBar.vue'
import PageTitleBar from '@/components/Parts/GlobalHeaderForLoginedView/PageTitleBar/PageTitleBar.vue'
import FlashLine    from '@/components/Parts/GlobalHeaderForLoginedView/TimesFlashLine/TimesFlashLine.vue'

import ProgressBarMixin from '@/components/Parts/GlobalHeaderForLoginedView/ProgressBarMixin.js'

export default {
  name        : 'PAGlobalHeaderForLoginedView',

  mixins : [
    ProgressBarMixin
  ],
  
  components  : {
    ProgressBar,
    IconBar,
    PageTitleBar,
    FlashLine
  },

  data(){
    return {
      globalHeaderClass : [],

      couldDataLoad     : false,

      mountedDate       : null
    };
  },

  computed : {
    isMountedLoginedViewPage(){
      return this.$store.state.layouts.isMountedLoginedViewPage;
    },

    isVisiblePageContent(){
      return this.$store.state.layouts.isVisiblePageContent;
    }
  },

  watch : {
    isMountedLoginedViewPage(value){
      if(value === true){
        // This time will use check login_point_modal
        this.mountedDate   = this.$moment(new Date());

        this.$nextTick(() => {
          this.couldDataLoad = true;
        });
      }else{
        // this.lastCharacterLevelPointLogId = null;
        this.couldDataLoad = false;
      }
    },

    isVisiblePageContent : {
      handler(value){
        if(value === true){
          this.globalHeaderClass = ['pa-global-header-visible'];
        }else{
          this.globalHeaderClass = [];
        }
      },
      immediate: true
    },
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-global-header{
  width:100vw;
  position: fixed;
  z-index: 9;
  top:0;
  left:0;
  opacity:0;

  &-visible{
    opacity:1;
  }

  @include from($desktop) {
    background-color:#540e23;
    padding:4px 0 0;
  }

  .only{
    &-pc{
      display: none;
    }

    &-mobile{
      display: block;
    }

    @include from($desktop) {
      &-pc{
        display: block;
      }

      &-mobile{
        display: none;
      }
    }
  }

  .main-field{
    @include from($desktop) {
      // box-sizing: content-box;
      display: flex;
      flex-direction: row;
      max-width:1000px;
      padding:4px 12px 5px;
      margin:0 auto;

      .left-side{
        width:50%;
      }

      .right-side{
        width:50%;
        margin-top:-2px;
      }
    }
  }
}
</style>